import { createAsyncActionType } from './index';

export const HOME_LEARNING_EVENTS_LIST_GET = createAsyncActionType('home', 'HOME_LEARNING_EVENTS_LIST_GET');
export const HOME_TOJ_PLANNED_LIST_GET = createAsyncActionType('home', 'HOME_TOJ_PLANNED_LIST_GET');
export const HOME_MANDATORY_TRAINING_LIST_GET = createAsyncActionType('home', 'HOME_MANDATORY_TRAINING_LIST_GET');
export const HOME_OPTIONAL_COURSES_LIST_GET = createAsyncActionType('home', 'HOME_OPTIONAL_COURSES_LIST_GET');
export const HOME_FAVOURITE_LIST_GET = createAsyncActionType('home', 'HOME_FAVOURITE_LIST_GET');
export const HOME_SET_FAVOURITE = createAsyncActionType('home', 'HOME_SET_FAVOURITE');
